// BumbleBee chat updates (new chat / new message)
// Direction: server -> client
import emitter from "../../core/wsEmitter";
import queryClient from "../../../query/queryClient";
import { store } from "../../../store/store";
import { setSessionData } from "../../../store/slices/session.slice";
import { SESSION_TYPE_BUMBLEBEE_STATUS } from "../../../types/bumblebee.type";
import { playMessageNotificationSound } from "../../../utils/playMessageNotificationSound";
import { fetchBumblebeeSessionData } from "../../../../pages/main/components/workspace/components/chat/components/history/service/load-bumblebee-session.service";
import { markBumblebeeChatReadService } from "../../../../pages/main/components/workspace/components/chat/components/history/service/mark-bumblebee-read.service";
import { shouldMarkChatRead } from "../../../utils/should-mark-chat-read";
type BumblebeeUpdateEvent = {
	event?: "session_created" | "message_appended";
	session_id?: string;
	campaign_id?: string;
};

const refreshOpenBumblebeeChat = async (
	sessionId: string,
	markRead: boolean,
) => {
	const nextSessionData = await fetchBumblebeeSessionData(sessionId);
	if (!nextSessionData) return;

	store.dispatch(setSessionData(nextSessionData));

	if (markRead) {
		const ok = await markBumblebeeChatReadService(sessionId);
		if (ok) {
			await queryClient.invalidateQueries({
				queryKey: ["bumblebee-sessions-data"],
			});
		}
	}
};

emitter.on("bumblebee.update", (data: BumblebeeUpdateEvent) => {
	void (async () => {
		await queryClient.invalidateQueries({
			queryKey: ["bumblebee-sessions-data"],
		});

		if (data.event === "message_appended") {
			playMessageNotificationSound();
		}

		const { sessionId, activeChatKind } = store.getState().session;		if (
			activeChatKind !== SESSION_TYPE_BUMBLEBEE_STATUS ||
			!sessionId ||
			!data?.session_id ||
			data.session_id !== sessionId
		) {
			return;
		}

		await refreshOpenBumblebeeChat(
			sessionId,
			data.event === "message_appended" && shouldMarkChatRead(),
		);
	})();
});
